import { render, staticRenderFns } from "./AdServerGridPromotionPlacement.vue?vue&type=template&id=c2dcdc7e"
import script from "./AdServerGridPromotionPlacement.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdServerGridPromotionPlacement.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports